import apiClient from './client';

export interface Snapshot {
  id: string;
  canvasId: string;
  name: string;
  createdById: string;
  data: Record<string, unknown>;
  createdAt: string;
}

export const snapshotsApi = {
  list: async (canvasId: string): Promise<Snapshot[]> => {
    const { data } = await apiClient.get<Snapshot[]>(
      `/canvases/${canvasId}/snapshots`,
    );
    return data;
  },

  create: async (canvasId: string, name?: string): Promise<Snapshot> => {
    const { data } = await apiClient.post<Snapshot>(
      `/canvases/${canvasId}/snapshots`,
      { name },
    );
    return data;
  },

  getById: async (canvasId: string, snapshotId: string): Promise<Snapshot> => {
    const { data } = await apiClient.get<Snapshot>(
      `/canvases/${canvasId}/snapshots/${snapshotId}`,
    );
    return data;
  },

  restore: async (canvasId: string, snapshotId: string): Promise<void> => {
    await apiClient.post(
      `/canvases/${canvasId}/snapshots/${snapshotId}/restore`,
    );
  },
};

export default snapshotsApi;
